import React from 'react';
import { Link } from 'react-router-dom';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';

import './FooterD7.scss';

const TruckIcon = (props) => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false" {...props}>
    <path
      fill="currentColor"
      d="M3 6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2h2.6a2 2 0 0 1 1.7 1l1.1 1.9c.4.6.6 1.3.6 2v2.2a2 2 0 0 1-2 2h-.2a3 3 0 0 1-5.6 0H11a3 3 0 0 1-5.6 0H5a2 2 0 0 1-2-2V6Zm14 4v4h5v-1.2c0-.3-.1-.7-.3-1l-1-1.8H17Zm-1 7h1.4a3 3 0 0 1 5.6 0h.0V16H3v1a1 1 0 0 0 1 1h1.4a3 3 0 0 1 5.6 0H16Zm-8.2 2a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Zm12 0a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z"
    />
  </svg>
);

const FooterD7 = ({ client }) => {
  const year = new Date().getFullYear();
  const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  const fb = client?.link_fb || '';
  const ig = client?.link_ig || '';

  return (
    <footer className="d7-footer" role="contentinfo">
      <div className="d7-footer__container">
        <div className="d7-footer__grid">
          <div className="d7-footer__col">
            <h3 className="d7-footer__title">
              {client?.description ? `${client.description} Informacion` : 'Informacion'}
            </h3>

            <div className="d7-footer__social">
              {fb ? (
                <a href={fb} aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                  <FacebookIcon />
                </a>
              ) : null}
              {ig ? (
                <a href={ig} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                  <InstagramIcon />
                </a>
              ) : null}
            </div>
          </div>

          <div className="d7-footer__col">
            <h3 className="d7-footer__title">Contacto</h3>
            <ul className="d7-footer__list">
              <li><Link to="/contacto">Contacto</Link></li>
              <li><Link to="/contacto">Local</Link></li>
            </ul>
          </div>
        </div>

        <div className="d7-footer__trust" aria-label="Pagos y envios">
          <div className="d7-footer__trustItem">
            <div className="d7-footer__trustLabel">Logistica</div>
            <div className="d7-footer__ship">
              <TruckIcon />
              <span>Puerta a puerta</span>
            </div>
          </div>
        </div>

        <div className="d7-footer__bottom">
          <p className="d7-footer__copy">
            &copy; {year} &middot; Derechos reservados por{' '}
            <a
              href="https://info.jaypionba.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="d7-footer__brand"
            >
              Jaypion
            </a>
          </p>

          <button
            className="d7-footer__totop"
            onClick={scrollToTop}
            type="button"
            aria-label="Ir al inicio"
          >
            <span>IR AL INICIO</span>
            <i className="fa fa-arrow-up" aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default FooterD7;
